import React, { useState, useEffect, useRef } from 'react'
import { useLanguageContext } from '../../../contexts/LanguageContext'
import './Header.css'
import { Link } from 'react-router-dom'

const Header: React.FC = () => {
  const { content, language, setLanguage } = useLanguageContext()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false)
  const languageDropdownRef = useRef<HTMLDivElement>(null)
  const [isScrolled, setIsScrolled] = useState(false)

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen)
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false)
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (languageDropdownRef.current && !languageDropdownRef.current.contains(event.target as Node)) {
        setIsLanguageDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // Close mobile menu when language changes
  useEffect(() => {
    if (isMobileMenuOpen) {
      setIsMobileMenuOpen(false)
    }
  }, [language])

  // Detect scroll for blur/background change
  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 10)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <Link to="/home">
              <img src="assets/img/hero/logo.svg" height="50" alt="logo" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <ul className="nav-list">
              <li><a href="#mission">{content.header.nav.mission}</a></li>
              <li><a href="#solutions">{content.header.nav.solutions}</a></li>
              <li><a href="#roadmap">{content.header.nav.roadmap}</a></li>
              <li><a href="#token">{content.header.nav.token}</a></li>
              <li><a href="#team">{content.header.nav.team}</a></li>
              <li><a href="#contact">{content.header.nav.contact}</a></li>
              <li><a href="https://docs.makemyday.tips">{content.header.nav.docs}</a></li>
              <li><a href="https://blog.makemyday.tips">{content.header.nav.blog}</a></li>
            </ul>
          </nav>

          {/* Right side - Sign Up and Language */}
          <div className="header-right">
            {/* <button className="btn btn-secondary">
              <span>{content.header.signUp}</span>
            </button> */}
            {/* <div className="language-dropdown" ref={languageDropdownRef}>
              <button 
                className="language-switcher"
                onClick={toggleLanguageDropdown}
              >
                <span>{language === 'en' ? 'EN' : 'МК'}</span>
                <span className={`dropdown-arrow ${isLanguageDropdownOpen ? 'rotated' : ''}`}>▼</span>
              </button>
              
              {isLanguageDropdownOpen && (
                <div className="language-dropdown-menu">
                  <button 
                    className={`language-option ${language === 'en' ? 'active' : ''}`}
                    onClick={() => handleLanguageChange('en')}
                  >
                    EN
                  </button>
                  <button 
                    className={`language-option ${language === 'mk' ? 'active' : ''}`}
                    onClick={() => handleLanguageChange('mk')}
                  >
                    МК
                  </button>
                </div>
              )}
            </div> */}
            <a href='https://x.com/MakeMyDayAI' className='social-icon' target='_blank'>
              <img src="assets/icons/x.svg"></img>
            </a>
            <a href='https://t.me/i_make_your_day_bot'className='social-icon' target='_blank'>
              <img src="assets/icons/telegram.svg"></img>
            </a>
            <a href='https://www.facebook.com/profile.php?id=61584051100792' className='social-icon' target='_blank'>
              <img src="assets/icons/facebook.svg"></img>
            </a>
            <a href='https://www.instagram.com/makemydayAI' className='social-icon' target='_blank'>
              <img src="assets/icons/instagram.svg"></img>
            </a>
            <a href='https://www.tiktok.com/@makemydayAI' className='social-icon' target='_blank'>
              <img src="assets/icons/tiktok.svg"></img>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav key={language} className={`nav-mobile ${isMobileMenuOpen ? 'open' : ''}`}>

          <ul key={`nav-${language}`} className="nav-mobile-list">
            <li><a href="#mission" onClick={closeMobileMenu}>{content.header.nav.mission}</a></li>
            <li><a href="#solutions" onClick={closeMobileMenu}>{content.header.nav.solutions}</a></li>
            <li><a href="#roadmap" onClick={closeMobileMenu}>{content.header.nav.roadmap}</a></li>
            <li><a href="#token" onClick={closeMobileMenu}>{content.header.nav.token}</a></li>
            <li><a href="#team" onClick={closeMobileMenu}>{content.header.nav.team}</a></li>
            <li><a href="#contact" onClick={closeMobileMenu}>{content.header.nav.contact}</a></li>
            <li><a href="https://docs.makemyday.tips" onClick={closeMobileMenu}>{content.header.nav.docs}</a></li>
            <li><a href="https://blog.makemyday.tips" onClick={closeMobileMenu}>{content.header.nav.blog}</a></li>
            {/* <li className="mobile-signup">
              <button className="btn btn-primary btn-large">
                {content.header.signUp}
              </button>
            </li> */}
            {/* <li className="mobile-language">
              <div className="mobile-language-buttons">
                <button
                  className={`mobile-language-btn ${language === 'en' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('en')}
                >
                  EN
                </button>
                <button
                  className={`mobile-language-btn ${language === 'mk' ? 'active' : ''}`}
                  onClick={() => handleLanguageChange('mk')}
                >
                  МК
                </button>
              </div>
            </li> */}
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header 